import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Facebook, Instagram, Youtube } from "lucide-react";
import { useSettings } from "@/lib/settings";

export function Footer() {
  const settings = useSettings();
  return (
    <footer className="bg-navy text-slate-300 mt-20" data-testid="footer">
      <div className="container-page py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-1">
          <div className="flex items-center gap-3 mb-4">
            <img src="/assets/logo-bawaslu-full.png" alt="Logo Bawaslu Provinsi Sulawesi Tenggara" className="h-12 w-auto" />
          </div>
          <div className="mb-4">
            <div className="font-extrabold text-white">HARMONI BAWASLU</div>
            <div className="text-[11px] text-slate-400">Satu Pintu Komunikasi Publik</div>
          </div>
          <p className="text-sm leading-relaxed text-slate-400">
            {settings?.footer_description || "Platform komunikasi publik Bawaslu Provinsi Sulawesi Tenggara yang menghubungkan lembaga dengan masyarakat, media, dan komunitas."}
          </p>
        </div>
        <div>
          <h4 className="text-white font-bold mb-4 text-sm">Layanan Publik</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/suara-masyarakat" className="hover:text-white transition-colors">Suara Masyarakat</Link></li>
            <li><Link to="/media-center" className="hover:text-white transition-colors">Media Center</Link></li>
            <li><Link to="/tanya-bawaslu" className="hover:text-white transition-colors">Tanya Bawaslu</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-bold mb-4 text-sm">Informasi</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/info" className="hover:text-white transition-colors">Info Bawaslu</Link></li>
            <li><Link to="/edukasi" className="hover:text-white transition-colors">Edukasi Pemilu</Link></li>
            <li><Link to="/agenda" className="hover:text-white transition-colors">Agenda Bawaslu</Link></li>
            <li><Link to="/tentang" className="hover:text-white transition-colors">Tentang HARMONI</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-white font-bold mb-4 text-sm">Kontak</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-2.5"><MapPin className="h-4 w-4 text-brandred shrink-0 mt-0.5" /> {settings?.contact_address || "Jl. Balai Kota IV No. 1, Kendari"}</li>
            <li className="flex gap-2.5"><Phone className="h-4 w-4 text-brandred shrink-0 mt-0.5" /> {settings?.contact_phone || "(0401) 3122345"}</li>
            <li className="flex gap-2.5"><Mail className="h-4 w-4 text-brandred shrink-0 mt-0.5" /> {settings?.contact_email || "sultra@bawaslu.go.id"}</li>
          </ul>
          <div className="flex gap-3 mt-4">
            <a href="#" className="h-9 w-9 rounded-full bg-white/10 hover:bg-brandred flex items-center justify-center transition-colors"><Facebook className="h-4 w-4" /></a>
            <a href="#" className="h-9 w-9 rounded-full bg-white/10 hover:bg-brandred flex items-center justify-center transition-colors"><Instagram className="h-4 w-4" /></a>
            <a href="#" className="h-9 w-9 rounded-full bg-white/10 hover:bg-brandred flex items-center justify-center transition-colors"><Youtube className="h-4 w-4" /></a>
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-page py-5 text-xs text-slate-400 flex flex-col sm:flex-row justify-between gap-2">
          <span>© 2026 Bawaslu Provinsi Sulawesi Tenggara. Prototype Rencana Aksi Perubahan.</span>
          <span>Dikembangkan untuk penguatan Hukum, Humas &amp; Data Informasi.</span>
        </div>
      </div>
    </footer>
  );
}
